import { render, staticRenderFns } from "./tree_item_body.vue?vue&type=template&id=3afba8cc&"
import script from "./tree_item_body.vue?vue&type=script&lang=js&"
export * from "./tree_item_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports